import { isOn } from './flags'

export const appConfig = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL,
  appUrl: process.env.NEXT_PUBLIC_APP_URL,
  settings: {
    //FF
    freeFundAirdropped: true,
    genesisNftMigrated: true,
    showTreasuryOverview: true,
    stakingGenesisNftSetup: true,
    stakingGenesisNftClaimingEnabled: true,
    vestingEnabled: true,
    wlthContractDeployed: true,
    dexIntegrated: true,
    stakingContractDeployed: true,
    // Other
    freeFundDeadline: '2024-03-13T17:00:00Z',
    tier1InvestmentPeriod: 1000 * 60 * 60 * 24, // 24 hours
    //genesis nft
    genesisNftVestingStartDate: '2024-05-30T11:15:00Z',
    genesisNftVestingPeriodInYears: 2,
    //strategic partners 2
    strategicPartners2VestingStartDate: '2024-05-30T12:15:00Z',
    strategicPartners2VestingPeriodInMonths: 18,
    //strategic partners 1
    strategicPartners1VestingStartDate: '2024-11-26T12:15:00Z',
    strategicPartners1VestingPeriodInMonths: 18,
    //staking for bonus
    stakingForBonusWindowOpens: parseInt(
      process.env.NEXT_PUBLIC_STAKING_FOR_BONUS_WINDOW_OPENS || '0',
    ),
    stakingForBonusWindowCloses: parseInt(
      process.env.NEXT_PUBLIC_STAKING_FOR_BONUS_WINDOW_CLOSES || '0',
    ),
    stakingForBonusEnd: parseInt(process.env.NEXT_PUBLIC_STAKING_FOR_BONUS_END || '0'),
    marketplaceEnabled: isOn('marketplace'),
    marketplaceBidsEnabled: isOn('marketplaceBids'),
    rewardsEnabled: isOn('rewards'),
    allowedAliasDomains: (process.env.NEXT_PUBLIC_ALLOWED_ALIAS_DOMAINS || '')
      .split(',')
      .map((domain) => domain.trim())
      .filter((domain) => domain.length > 0),
  },
  tokenEncryptionKey: process.env.NEXT_PUBLIC_TOKEN_ENCRYPTION_KEY,
  discourseUrl: process.env.NEXT_PUBLIC_DISCOURSE_URL,
  strapApiUrl: `${process.env.NEXT_PUBLIC_STRAPI_URL}/api`,
  strapiToken: process.env.NEXT_PUBLIC_STRAPI_TOKEN,
  strapiBaseURL: process.env.NEXT_PUBLIC_STRAPI_URL,
  transakApiKey: process.env.NEXT_PUBLIC_TRANSAK_API_KEY,
  transakEnv: process.env.NEXT_PUBLIC_TRANSAK_ENV,
  transakApiBaseUrl: process.env.NEXT_PUBLIC_TRANSAK_API_BASE_URL,
  /** Third-party HTTP APIs (not NEXT_PUBLIC_API_URL backend). */
  discourseEndpoints: {
    session: {
      sso: '/session/sso',
    },
  },
  cache: {
    fund: {
      staleTime: 1000 * 60 * 2, // 2 minutes
    },
    investmentNft: {
      staleTime: 20 * 1000,
    },
    genesisNftStakingRewards: {
      staleTime: 20 * 1000,
    },
    canUserInvestInFund: {
      staleTime: 1000 * 60 * 2,
    },
    genesisNft: {
      staleTime: 1000 * 60 * 2, // 2 minutes
    },
    idoBanner: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
    stakeForBonusRewardInfo: {
      staleTime: 1000 * 60 * 2, // 2 minutes
    },
    me: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
  endpoints: {
    v1: {
      me: {
        main: '/me',
        termsAck: '/me/terms-ack',
        socials: {
          main: '/me/socials',
          verify: '/me/socials/verify',
        },
        wallets: {
          main: '/me/wallets',
          primary: '/me/wallets/primary',
          add: '/me/wallets/add',
        },
        missions: '/me/missions',
        stakingSummary: '/me/staking-summary',
        leaderboard: '/me/leaderboard',
        referred: '/me/referred',
        referralDashboard: '/me/referral-dashboard',
        canSponsorTransaction: '/me/gas-sponsorship-status',
      },
      news: {
        main: '/news',
        sources: '/news/sources',
      },
      blogs: {
        main: '/blogs',
      },

      auth: {
        register: {
          main: '/auth/register',
          verify: '/auth/register/verification',
        },
        login: {
          main: '/auth/login',
          loginByPrivyToken: '/auth/login/privy-token',
        },
        syncDiscourseRoles: {
          main: '/auth/sync-discourse-roles',
        },
        emailConfirmation: {
          main: '/auth/email-confirmation',
          verify: '/auth/email-confirmation/verification',
        },
        changeEmailConfirmation: {
          main: '/auth/change-email-confirmation',
          verify: '/auth/change-email-confirmation/verification',
        },
        logout: '/auth/logout',
        refreshTokens: '/auth/refresh-tokens',
        discord: '/auth/discord',
        google: '/auth/google',
        facebook: '/auth/facebook',
        telegram: '/auth/telegram',
        instagram: '/auth/instagram',
        telegramStatus: '/auth/telegram/status',
        twitter: '/auth/twitter',
        twitterToken: '/auth/twitter/token',
        socialsStatus: '/auth/socials/status',
        deleteSocial: '/auth/social/:provider',
      },
      notifications: {
        main: '/notifications',
        markRead: '/notifications/mark-read',
        markAllRead: '/notifications/mark-all-read',
        content: (notificationId: string) =>
          `/notifications/${encodeURIComponent(notificationId)}/content`,
      },
      beehiiv: {
        sliceHoldings: '/beehiiv/user/slice-holdings',
        walletFunded: '/beehiiv/user/wallet-funded',
      },
      users: {
        main: '/users',
        mainWithId: '/users/:userId',
        avatar: '/users/:userId/avatar',
        avatarBucketUrl: process.env.NEXT_PUBLIC_USER_AVATAR_BUCKET_URL,
        resendConfirmationEmail: '/users/me/confirmation-email',
        privy: '/users/privy',
        referred: {
          global: '/users/referred/global',
        },
      },
      referralGiveaway: {
        leaderboard: '/referral-giveaway/leaderboard',
        positionWithNeighbors: '/referral-giveaway/leaderboard/position-with-neighbors',
        campaign: '/referral-giveaway/campaign',
      },
      metadata: {
        uploadJson: '/metadata/upload-json',
      },
      transactions: {
        send: '/privy-transaction/send-transaction',
      },
      priceHistory: {
        wlth: '/token/WLTH/history',
      },
      price: {
        eth: '/token/ETH/price',
      },
      treasuryBuckets: {
        main: '/treasury-buckets',
      },
      community: {
        latestTopics: '/community/latest-topics',
        popularTopics: '/community/popular-topics',
      },
      communityFund: {
        main: `/${process.env.NEXT_PUBLIC_COMMUNITY_FUND_URL_ID}`,
        allStakers: {
          main: '/stakers',
          allStakersMyPosition: '/stakers/my-position',
          allStakersMyPositionWithNeighbors: '/stakers/my-position-with-neighbors',
        },
        topStakers: {
          main: '/stakers/top',
          topStakersMyPosition: '/stakers/top/my-position',
          topStakersMyPositionWithNeighbors: '/stakers/top/my-position-with-neighbors',
        },
      },
      wlth: {
        main: '/wlth',
        last: '/wlth/last',
      },
      featureFlags: {
        main: '/ff',
      },
      rewards: {
        freeFund: {
          freeFundProjects: `/funds/${process.env.NEXT_PUBLIC_STRAPI_FREE_FUND_ID}`,
          projects: '/app-projects',
          project: '/app-projects/:projectId',
          quests: '/rew-quests',
          quest: '/rew-quests/:questId',
          questsCount: `/funds/${process.env.NEXT_PUBLIC_STRAPI_FREE_FUND_ID}`,
          missions: '/rew-missions',
          mission: '/rew-missions/:missionId',
          submitProof:
            '/projects/:strapiProjectId/quests/:strapiQuestId/missions/:strapiMissionId/proof',
          submitMedia:
            '/projects/:strapiProjectId/quests/:strapiQuestId/missions/:strapiMissionId/media',
          leaderboard: {
            main: '/rewards/leaderboard',
            position: '/quests/leaderboard/position',
            closestUsers: '/quests/leaderboard/closest-users',
          },
        },
        v2: {
          mission: '/promote-missions/:missionId',
          missions: '/promote-missions',
        },
        userRewards: '/me/rewards',
      },
      funds: {
        main: '/funds',
        mainWithId: '/funds/:fundId',
        fundHomepage: '/app-homepages',
      },
      projects: {
        main: '/app-projects',
        mainWithId: '/app-projects/:projectId',
      },
      userTerms: {
        main: '/user-term',
      },
      termsAndConditions: {
        main: '/term-and-conditions',
      },
      privacyPolicy: {
        main: '/privacy-policy',
      },
      wlthPolicy: {
        main: '/wlth-policy',
      },
      idoBanner: {
        main: '/ido-banner',
      },
      investments: {
        genesisNftHolder: '/investments/genesis-nft-holder',
        canInvest: '/investments/can-invest',
      },
      strapiHistory: {
        field: '/strapi-history/:entity/:strapiField',
        latest: '/strapi-history/:entity/:strapiField/latest',
      },
      marketplace: {
        collection: '/marketplace/collection/:contractAddresses',
        nftActivity: '/marketplace/offer-activity/:contractAddress/:nftId',
        getOffers: '/marketplace/offer',
        createOffer: '/marketplace/offer',
        updateOffer: '/marketplace/offer/:offerId',
        deleteOffer: '/marketplace/offer/:offerId',
        closeOffer: '/marketplace/offer/:offerId/close',
        delistOffer: '/marketplace/offer/:offerId/delist',
        pingApi: '/marketplace/ping',
        offersCount: '/marketplace/offers/count',
        getMyOffers: '/marketplace/offers/:ownerWalletAddress',
        createOfferActivity: '/marketplace/offer-activity',
        refreshOffer: '/marketplace/offer/:contractAddress/:nftId/refresh',
        allocationFilter: '/marketplace/offer/allocation/filter',
        batchCloseOffers: '/marketplace/offers/batch-close',
        createBid: '/marketplace/bid',
        listingBids: '/marketplace/bids/listing/:listingId',
        myBids: '/marketplace/bids/mine',
        sellerBidInbox: '/marketplace/bids/inbox/:ownerWalletAddress',
      },
      cart: {
        main: '/cart',
        items: '/cart/items',
        itemById: '/cart/items/:itemId',
        validate: '/cart/validate',
        clearItems: '/cart/items',
        itemsInterest: '/cart/items/interest',
      },
      favorites: {
        main: '/favorites',
        items: '/favorites/items',
        itemById: '/favorites/items/:itemId',
        exists: '/favorites/exists',
        check: '/favorites/check',
      },
      preIpoInterest: {
        main: '/pre-ipo-interest',
        myRegistration: '/pre-ipo-interest/:fundUrlId/me',
        eligibility: '/pre-ipo-interest/:fundUrlId/eligibility',
      },
      st0x: {
        tokens: '/st0x/tokens',
        prices: '/st0x/prices',
        quote: '/st0x/swap/quote',
        calldata: '/st0x/swap/calldata',
      },
      userInteractionEvents: {
        main: '/user-interaction-events',
      },
      appDownloadClicks: {
        main: '/app-download-clicks',
      },
      giftBundle: {
        getRecipientWalletAddress: '/gift-bundle/recipient-wallet-address',
        emailRecipientGift: '/gift-bundle/email-recipient-gift',
        emailSenderRecipientClaim: '/gift-bundle/email-sender-recipient-claim',
        emailRecipientSenderRevoked: '/gift-bundle/email-recipient-sender-revoked',
        emailRecipientReminder: '/gift-bundle/email-recipient-reminder',
        claimGiftGasless: '/gift-bundle/claim-gasless',
      },
    },
    twitter: {
      follow: '/twitter/follow',
      like: '/twitter/like',
      retweet: '/twitter/retweet',
    },
  },
  strapi: {
    commonWealthProjectUrlId: process.env.NEXT_PUBLIC_COMMON_WEALTH_PROJECT_URL_ID,
    communityFundUrlId: process.env.NEXT_PUBLIC_COMMUNITY_FUND_URL_ID,
  },
  fiatApi: {
    endpoints: {
      order: '/fiat/orders/:fundId',
      orders: '/fiat/orders',
      wallet: '/fiat/user/wallet',
      cashOut: '/fiat/cash-out/:nftId',
    },
  },
  transak: {
    endpoints: {
      quotes: '/api/v1/pricing/public/quotes',
    },
  },
}
